import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import '../checkout.css';
import QRCode from 'qrcode.react';
import _ from 'lodash';
import { API } from '../../../constants/api.constants';
import Countdown, { zeroPad } from 'react-countdown';

let ping;
let socket;

class DialogThaiQR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentStatus: 'Pending',
      dialogConfirmCancelThaiQr: false,
      timeStart: Date.now() + 300000
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    const { dialogThaiQR, thaiQRorderingData } = this.props;
    if (
      !_.isEqual(prevProps.dialogThaiQR, dialogThaiQR) ||
      !_.isEqual(prevProps.thaiQRorderingData, thaiQRorderingData)
    ) {
      if (
        dialogThaiQR &&
        thaiQRorderingData &&
        thaiQRorderingData.vistatransno
      ) {
        await this.responseSocket('on');
        this.setState({ timeStart: Date.now() + 300000 });
      }
    }
  }

  componentWillUnmount() {
    if (ping) {
      clearInterval(ping);
    }
  }

  countDown = ({ minutes, seconds, completed }) => {
    if (completed) {
      this.cancelThaiQrPayment(true);
      return <span>please, try again.</span>
    } else {
      return (
        <span>
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };

  responseSocket = async () => {
    const { thaiQRorderingData, ThaiQRConfirmPayment } = this.props;

    socket = new WebSocket(API.WEBSOCKET);
    socket.onopen = (event) => {
      ping = setInterval(() => {
        socket.send('ping');
      }, 20000);
    };

    socket.onmessage = (event) => {
      const message = event.data;

      switch (message) {
        case 'Connected':
          socket.send(thaiQRorderingData.vistatransno);
          break;

        case 'Paid':
          this.handleCloseDialogThaiQR();
          ThaiQRConfirmPayment(true);
          break;

        case 'Expired':
          this.handleCloseDialogThaiQR();
          ThaiQRConfirmPayment(false);
          break;

        default:
          break;
      }
    };

    socket.onclose = () => {
      this.handleCloseDialogThaiQR();
    };
  };

  handleCloseDialogThaiQR = async () => {
    const { CloseDialogThaiQR } = this.props;
    socket && (await socket.close());
    ping && (clearInterval(ping));
    CloseDialogThaiQR();
  };

  cancelThaiQrPayment = async () => {
    const { ThaiQrCancelPayment, thaiQRorderingData } = this.props;
    if (thaiQRorderingData) {
      await ThaiQrCancelPayment(thaiQRorderingData.vistatransno, () => this.handleCloseDialogThaiQR());
    }
  }

  CloseDialogConfirmCancelThaiQr = () => {
    this.setState({
      dialogConfirmCancelThaiQr: false
    });
  }

  OpenDialogConfirmCancelThaiQr = async () => {
    const { ThaiQrInquirePayment, thaiQRorderingData } = this.props;
    if (thaiQRorderingData && !this.state.pending) {
      await ThaiQrInquirePayment(thaiQRorderingData.vistatransno, () => {
        this.setState({
          dialogConfirmCancelThaiQr: true
        });
      });
    }
  }

  renderDialogConfirmCancelThaiQr = () => {
    const { wording } = this.props;
    const { dialogConfirmCancelThaiQr } = this.state;
    return (
      <Modal
        visible={dialogConfirmCancelThaiQr}
        width='450'
        effect='fadeInUp'
        onClickAway={() => this.CloseDialogConfirmCancelThaiQr()}>
        <div style={{ margin: 20 }}>
            <div className='dialog-header mb-50'>
                <h4 style={{ color: '#ef5659' }}>
                    {wording.checkoutPage.dialogConfirmCancelThaiQr.title}
                </h4>
            </div>
            <div className='dialog-action row'>
                <div className='col-md-6'>
                    <button
                        style={{ width: '100%' }}
                        className='btn btn-md btn-dark'
                        onClick={() => this.cancelThaiQrPayment().then(() => this.CloseDialogConfirmCancelThaiQr())}>
                        {wording.checkoutPage.dialogConfirmCancelThaiQr.yes}
                    </button>
                </div>
                <div className='col-md-6'>
                    <button
                        style={{ width: '100%' }}
                        className='btn btn-md btn-light-red'
                        onClick={() => this.CloseDialogConfirmCancelThaiQr()}>
                        {wording.checkoutPage.dialogConfirmCancelThaiQr.no}
                    </button>
                </div>
            </div>
        </div>
      </Modal>
    )
  }

  render() {
    const { wording, dialogThaiQR, thaiQRorderingData } = this.props;
    const { paymentStatus, dialogConfirmCancelThaiQr, timeStart } = this.state;

    return (
      <>
        <Modal
          visible={dialogThaiQR}
          width="450"
          effect="fadeInUp"
          onClickAway={() => this.OpenDialogConfirmCancelThaiQr()}>
          <div className="m-20">
            <div className="dialog-header">
              <h4 style={{ color: '#2d64cf' }}>
                {wording.checkoutPage.dialogThaiQR.title}
              </h4>
            </div>
            <div className="dialog-body mt-20 mb-20 center">
              {dialogThaiQR && thaiQRorderingData && thaiQRorderingData.qrCode ? (
                <div className="thai-qr-payment">
                  <div className="logo-top"></div>
                  <div className="logo-promptpay"></div>
                  <QRCode
                    value={thaiQRorderingData.qrCode}
                    includeMargin
                    size={200}
                    imageSettings={{
                      src: "/assets/img/thai_qr_payment_logo.png",
                      height: 20,
                      width: 28
                    }}
                  />
                </div>
              ) : null}
              <br />
              <p style={{ color: '#000' }}>
                {dialogThaiQR && thaiQRorderingData && thaiQRorderingData.qrCode
                  ? paymentStatus === 'Pending'
                    ? wording.checkoutPage.dialogThaiQR.WaitingForPayment
                    : paymentStatus === 'Paid'
                    ? wording.checkoutPage.dialogThaiQR.PaymentCompleted
                    : wording.checkoutPage.dialogThaiQR.WaitingForPayment
                  : wording.checkoutPage.dialogThaiQR.WaitingForQRcode}{' '}
                <Countdown date={timeStart} renderer={this.countDown} />
              </p>
            </div>
          </div>
        </Modal>
        {dialogConfirmCancelThaiQr && this.renderDialogConfirmCancelThaiQr()}
      </>
    );
  }
}

const mapStateToProps = ({ checkout, language }) => ({
  dialogThaiQR: checkout.dialogThaiQR,
  wording: language.wording,
  thaiQRorderingData: checkout.thaiQRorderingData
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      CloseDialogThaiQR: Actions.CloseDialogThaiQR,
      ThaiQRConfirmPayment: Actions.ThaiQRConfirmPayment,
      ThaiQrInquirePayment: Actions.ThaiQrInquirePayment,
      ThaiQrCancelPayment: Actions.ThaiQrCancelPayment,
      ThaiQrInquirePayment: Actions.ThaiQrInquirePayment
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogThaiQR);
